import * as React from "react";
//import axios from "axios";
import { Locale } from "../frame/Locale.js";
import { Request } from "./Request.js";
export { Service };
/**
 * Помогает отправлять и обрабатывать запросы к REST микросервису.
 * @summary REST микросервис.
 * @example
 * import {Service} from "../personal-studio-components/component/Service";
 * const myService = new Service("http://uits-demo2.roweb.online/my-path");
 * function MyReactComponent()
 * {
 *   const getData = myService.useRequest("GET", "/my-sub-path", {id: 123});
 *   if(getData.isLoading())
 *     return "Данные загружаются...";
 *   else if(getData.hasError())
 *     return JSON.stringify(getData.getErrata());
 *   else // if(getData.isReady())
 *     return JSON.stringify(getData.getResponse());
 * }
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class Service {
  /**
   * @param {string} url Базовый адрес REST микросервиса.
   */
  constructor(url, name) {
    this.url = url;
    this.name = name;
    this.query = "";
    this.timeout = 10000;
  }
  /**
   * Асинхронное получение адреса (для ConfigService).
   * @returns {Promise<string>} - Базовый адрес REST микросервиса.
   * @async
   */
  async getURL() {
    return this.url;
  }

  /**
   * Хук для компонента React, отправляющий запрос к REST микросервису 
   * и отслеживающий изменения его статуса.
   * @param {string} method - "GET" или "POST".
   * @param {string} path - Внутренний путь относительно адреса микросервиса.
   * @param {Object} data - Передаваемые данные.
   * @returns {Request}
   */
  useRequest(method, path, data = null) {
    const [request, setState] = React.useState(new Request(
      {
        service: this,
        method: method,
        path: path,
        data: data,
        loading: true,
        errata: null,
      }));
    React.useEffect(() => { this.send({ method, path, data }, setResponse); }, []);
    return request;
    function setResponse(response) {
      if (!response) request.update(true, null, null);
      else if (response.error_type) request.update(false, null, response);
      else request.update(false, response, null);
      setState(new Request(request.state));
    }
  }
  /** Отправляет данные формы */
  async submit(submit_request, reload_request, setResponse) {
    const submit_response = await this.send(submit_request);
    if (submit_response.errors) return setResponse(submit_response);
    await this.send(reload_request, setResponse);
  }
  /** Отправляет простой запрос к сервису */
  async send(request, setResponse = null) {
    const retry = () => this.send(request, setResponse);
    // Отлавливаем медленные запросы в консоли
    let time = 0;
    const interval = setInterval(() => {
      time += this.timeout;
      const timezoneOffset = new Date().getTimezoneOffset() * 60000;
      const timeView =
        new Date(time + timezoneOffset).toLocaleTimeString();
      console.debug("Service:", "slow", request.path, timeView);
    }, this.timeout);
    try {
      console.debug("Service:",
        request.method, request.path, request.data ?? " ");
      if (!request.volatile && setResponse) setResponse(null);
      const service_url = await this.getURL();
      if (!service_url) throw locale.invalid("config." + this.name + "_service");
      let url = service_url;
      url += request.path;
      if ("." == service_url) url += ".json";
      url += this.query;
      //const { data } = await axios({ ...request, url });
      // Конвертация axios в fetch
      request.headers ??= {};
      if (request.method) request.method = String(request.method).toUpperCase();
      if (request.data) {
        if ("string" === typeof request.data
          || request.data instanceof FormData
          || request.data instanceof URLSearchParams)
          request.body = request.data;
        else {
          request.headers["Content-Type"] ??= "application/json";
          request.body = JSON.stringify(request.data);
        }
      }
      const response = await fetch(url, request);
      if (200 == response.status) {
        const data = await response.json();
        console.debug("Service:", "response", request.path, data);
        clearInterval(interval);
        if (setResponse) setResponse(data);
        return data;
      }
      else {
        const errata = await response.json();
        errata.error_type ??= "ajax";
        errata.errors ??= ["Некорректный ответ сервера"];
        errata.http_error = response.status;
        if (setResponse) errata.retry = retry;
        if ("auth" == errata.error_type) {
          const event = new ErrorEvent("error", { error: errata });
          window.dispatchEvent(event);
        }
        console.error("Service:", "error", request.path, errata);
        clearInterval(interval);
        if (setResponse) setResponse(errata);
        return errata;
      }
    }
    catch (error) {
      const errata = {
        error_type: "ajax",
        errors: [error.message ?? JSON.stringify(error)]
      };
      if (setResponse) errata.retry = retry;
      console.error("Service:", "error", request.path, errata);
      clearInterval(interval);
      if (setResponse) setResponse(errata);
      return errata;
    }
  }
  toString() {
    return this.url;
  }
}
/**
 * Локализация модуля.
 * @type {Locale}
 * @private
 */
const locale = new Locale("Service", {});
